import HeaderTitleAnalytics from '@/components/layouts/wrappers/LayoutAnalytics/HeaderAnalytics/HeaderTitleAnalytics';
import HeaderDatepickerAnalytics from '@/components/layouts/wrappers/LayoutAnalytics/HeaderAnalytics/HeaderDatepickerAnalytics';

const HeaderAnalytics = ({ title, periodSelected, setPeriodSelected, type, isGroup }) => {
    return (
        <>
            <HeaderTitleAnalytics title={title} isGroup={isGroup} />
            <div className="manipulation-header z-10 mb-10 flex items-center md:sticky md:top-10 md:mt-10">
                <div className="dark:shadow-icoDarkM w-full shadow-icoM">
                    <HeaderDatepickerAnalytics
                        type={type}
                        periodSelected={periodSelected}
                        setPeriodSelected={setPeriodSelected}
                    />
                </div>
            </div>
        </>
    );
};

export default HeaderAnalytics;
